<template>
  <section class="operational-order-panel" :class="{ 'is-compact': compact }">
    <h2 v-if="compact" class="operational-order-panel__heading gs-section-heading"><span>{{ $t("订单 · {0}", [$t(activeTabLabel)]) }}</span></h2>
    <div v-if="isGod && showShopFilter" class="ui-drawer__toolbar operational-order-drawer__shop-filter">
      <SelectionShopId
        v-model="selectedShopId"
        :all-sel="allowAllShops"
      />
    </div>

    <UiTabs v-model="activeTab" class="operational-order-tabs" type="card" variant="open-edges">
      <UiTabPane name="pending">
        <template slot="label">
          <span class="order-tab-label" :title="$t('未接单')"><i v-if="compact" class="iconfont icon-meiyoudingdan-01" aria-hidden="true"></i><span :class="{ 'order-tab-label__accessible': compact }">{{ $t("未接单") }}</span></span>
          <UiCountBadge size="large" :count="orderGroups.pendingList.length" />
        </template>
        <QuestTabs :compact="compact" :list="orderGroups.pendingList" :shopId="selectedShopId" type="未接单" />
      </UiTabPane>
      <UiTabPane name="processing">
        <template slot="label">
          <span class="order-tab-label" :title="$t('已接单')"><i v-if="compact" class="iconfont icon-yijiedan" aria-hidden="true"></i><span :class="{ 'order-tab-label__accessible': compact }">{{ $t("已接单") }}</span></span>
          <UiCountBadge size="large" :count="orderGroups.processingList.length" />
        </template>
        <QuestTabs :compact="compact" :list="orderGroups.processingList" :shopId="selectedShopId" type="已接单" />
      </UiTabPane>
      <UiTabPane name="shipped">
        <template slot="label">
          <span class="order-tab-label" :title="$t('已发货')"><i v-if="compact" class="iconfont icon-yunshuzhong" aria-hidden="true"></i><span :class="{ 'order-tab-label__accessible': compact }">{{ $t("已发货") }}</span></span>
          <UiCountBadge size="large" :count="orderGroups.shippedList.length" />
        </template>
        <QuestTabs :compact="compact"
          :list="orderGroups.shippedList"
          :shopId="selectedShopId"
          type="已发货"
          @close-drawer="$emit('close')"
        />
      </UiTabPane>
      <UiTabPane name="refund">
        <template slot="label">
          <span class="order-tab-label" :title="$t('退款处理')"><i v-if="compact" class="iconfont icon-tuikuan" aria-hidden="true"></i><span :class="{ 'order-tab-label__accessible': compact }">{{ $t("退款处理") }}</span></span>
          <UiCountBadge size="large" :count="orderGroups.requestedList.length" />
        </template>
        <QuestTabs :compact="compact" :list="orderGroups.requestedList" :shopId="selectedShopId" type="退款处理" />
      </UiTabPane>
    </UiTabs>
  </section>
</template>

<script>
import QuestTabs from '@/components/QuestTabs'
import SelectionShopId from '@/components/SelectionShopId'
import { getOrderStatusGroups } from '@/utils/operationalStatus'

export default {
  name: 'OperationalOrderPanel',
  components: { QuestTabs, SelectionShopId },
  props: {
    compact: { type: Boolean, default: false },
    tabRequest: { type: Object, default: null },
    showShopFilter: { type: Boolean, default: true },
    shopId: { type: [String, Number], default: '' },
    allowAllShops: { type: Boolean, default: false }
  },
  data () {
    return {
      activeTab: this.tabRequest?.tab || 'pending',
      activeShopId: this.normalizeShopId(this.shopId)
    }
  },
  computed: {
    activeTabLabel () { return { pending: '未接单', processing: '已接单', shipped: '已发货', refund: '退款处理' }[this.activeTab] },
    isGod () {
      return this.$store.state.user.is_god === true
    },
    selectedShopId: {
      get () { return this.activeShopId },
      set (shopId) {
        this.activeShopId = this.normalizeShopId(shopId)
        this.$emit('update:shop-id', this.activeShopId)
      }
    },
    orderGroups () {
      return getOrderStatusGroups(this.$store.state.paidOrderList, this.selectedShopId)
    }
  },
  watch: {
    tabRequest (request) {
      if (request?.tab) this.activeTab = request.tab
    },
    shopId (shopId) {
      const normalizedShopId = this.normalizeShopId(shopId)
      if (normalizedShopId !== this.activeShopId) this.activeShopId = normalizedShopId
    }
  },
  methods: {
    normalizeShopId (shopId) {
      const isGod = this.$store.state.user.is_god === true
      if (isGod && this.allowAllShops && (shopId === '' || shopId === null || typeof shopId === 'undefined')) return ''
      return String(shopId || this.$store.state.user.shop_id || '')
    }
  }
}
</script>

<style lang="scss" scoped>
.order-tab-label { display: inline-flex; align-items: center; justify-content: center; height: 100%; width: 100%; }
.order-tab-label > i { font-size: var(--ui-font-size-overlay-title); }
.order-tab-label__accessible { position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0; }
.operational-order-panel.is-compact { display: flex; flex-direction: column; height: 100%; min-height: 0; overflow: hidden; }
.operational-order-panel__heading { margin: 0; padding: var(--ui-space-md); font-size: var(--gs-font-heading); }
.is-compact .operational-order-drawer__shop-filter { padding: 0 var(--ui-space-sm) var(--ui-space-sm); }
.is-compact .operational-order-tabs { display: flex; flex-direction: column; min-height: 0; flex: 1; }
.is-compact .operational-order-tabs::v-deep .el-tabs__header { flex-shrink: 0; margin-bottom: 0; }
.operational-order-panel.is-compact .operational-order-tabs.ui-tabs.el-tabs--card::v-deep .el-tabs__nav { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); width: 100%; float: none; transform: none !important; }
.operational-order-panel.is-compact .operational-order-tabs.ui-tabs.el-tabs--card::v-deep .el-tabs__nav::before,
.operational-order-panel.is-compact .operational-order-tabs.ui-tabs.el-tabs--card::v-deep .el-tabs__nav::after { display: none; }
.operational-order-panel.is-compact .operational-order-tabs.ui-tabs.el-tabs--card::v-deep .el-tabs__item { min-width: 0; height: 44px; line-height: 43px; text-align: center; padding: 0 var(--ui-space-xs); }
.is-compact .operational-order-tabs::v-deep .el-tabs__content { flex: 1; min-height: 0; overflow: auto; }
.operational-order-tabs::v-deep .el-tabs__item {
  position: relative;
  overflow: visible;
}

.operational-order-tabs .ui-count-badge {
  position: absolute;
  z-index: 3;
  top: 1px;
  right: 1px;
}

/* 订单主体不使用 Element Collapse 默认的上下边线。 */
.operational-order-tabs::v-deep .el-collapse {
  border-top: 0;
  border-bottom: 0;
}

/* 待处理订单内容区沿用终端深色设计令牌，不暴露 Element 默认白色主题。 */
.operational-order-tabs::v-deep .el-collapse-item__header,
.operational-order-tabs::v-deep .el-collapse-item__wrap,
.operational-order-tabs::v-deep .el-collapse-item__content,
.operational-order-tabs::v-deep .el-descriptions__body,
.operational-order-tabs::v-deep .el-descriptions__table,
.operational-order-tabs::v-deep .el-descriptions-item__cell {
  color: var(--ui-text-regular);
  background: var(--ui-bg-panel);
}

.operational-order-tabs::v-deep .el-collapse-item__header,
.operational-order-tabs::v-deep .el-collapse-item__wrap,
.operational-order-tabs::v-deep .el-descriptions-item__cell {
  border-color: var(--ui-border-color-subtle);
}

.operational-order-tabs::v-deep .el-collapse-item__header {
  color: var(--ui-text-primary);
  border-bottom: 0;
}

.operational-order-tabs::v-deep .el-collapse-item {
  border-bottom: 1px solid var(--ui-border-color-subtle);
}

.operational-order-tabs::v-deep .el-collapse-item:last-child {
  border-bottom: 0;
}

.operational-order-tabs::v-deep .el-descriptions-item__label.is-bordered-label {
  color: var(--ui-text-primary);
  background: var(--ui-bg-elevated) !important;
}

</style>
